// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","firmReference":"_8kHtmD0YVasF97TpVCDsC"};